/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IConvexBoosterLike,
  IConvexBoosterLikeInterface,
} from "../IConvexBoosterLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
    ],
    name: "poolInfo",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "lptoken",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "address",
            name: "gauge",
            type: "address",
          },
          {
            internalType: "address",
            name: "crvRewards",
            type: "address",
          },
          {
            internalType: "address",
            name: "stash",
            type: "address",
          },
          {
            internalType: "bool",
            name: "shutdown",
            type: "bool",
          },
        ],
        internalType: "struct IConvexBoosterLike.PoolInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IConvexBoosterLike__factory {
  static readonly abi = _abi;
  static createInterface(): IConvexBoosterLikeInterface {
    return new utils.Interface(_abi) as IConvexBoosterLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IConvexBoosterLike {
    return new Contract(address, _abi, signerOrProvider) as IConvexBoosterLike;
  }
}
